<template>
  <div class="policy">
        <div class="policy__title">
            <h1>Пользовательское соглашение</h1>
        </div>
        <div class="policy_margin">
            <p>
                <em>редакция №2, дата утверждения: 03 октября 2018 года, дата размещения на Сайте: 03 октября 2018 года, дата начала действия: 03 октября 2018 года</em>
            </p>
            <p>
                Настоящее Соглашение является Публичной офертой, определяет условия использования Пользователями материалов и сервисов сайта https://ecodom04.com/, содержит все существенные условия, т.е. условия, которые признаны существенными законодательством РК или необходимы для оказания услуг, а также те условия, относительно которых по заявлению Исполнителя должно быть достигнуто соглашение, и определяет условия использования Пользователями материалов и сервисов сайта.
            </p>
            <p>
                Пользователи — физические лица (в том числе представители юридических лиц), обладающие возможностью регистрироваться на сайте https://ecodom04.com/, также пользоваться услугами, представленными Исполнителем.
            </p>
            <p>
                Исполнитель — правообладатель сайта https://ecodom04.com/ (ИП «Вольф Юлия Александровна»).
            </p>
            <h3>
                1. ПОНЯТИЯ И ТЕРМИНЫ, ИСПОЛЬЗУЕМЫЕ В НАСТОЯЩЕЙ ПУБЛИЧНОЙ ОФЕРТЕ
            </h3>
            <p>
                1.1. <b>Договор - Оферта</b> - это содержащее все существенные условия договора предложение, из которого усматривается воля лица, делающего предложение, заключить договор на указанных в предложении условиях с любым, кто отзовется на это предложение. Содержит все условия, которые признаны существенными законодательством или необходимы для оказания Услуг, а также те условия, относительно которых по заявлению Исполнителя должно быть достигнуто соглашение.
            </p>
            <p>
                1.1. <b>Договор - Оферта</b> - это содержащее все существенные условия договора предложение, из которого усматривается воля лица, делающего предложение, заключить договор на указанных в предложении условиях с любым, кто отзовется на это предложение. Содержит все условия, которые признаны существенными законодательством или необходимы для оказания Услуг, а также те условия, относительно которых по заявлению Исполнителя должно быть достигнуто соглашение.
            </p>
            <p>
                1.3. <b>Стороны</b> - сторонами Договора-Оферты являются совместно Исполнитель и Пользователь.
            </p>
            <p>
                1.4.  <b>Услуги</b> – заказы (электронные услуги, предоставляемые на территории Республики Казахстан, с применением Информационных технологий), совершенные Пользователями на товары Партнёров, с помощью сайта Исполнителя https://ecodom04.com/.
            </p>
            <p>
                1.5. <b>Исполнитель</b> — ИП «Вольф Юлия Александровна», которому принадлежат все соответствующие исключительные имущественные права на Сайт, включая права на доменное имя Сайта.
            </p>
            <p>
                1.6. <b>Пользователь</b> — лицо, осуществившее Акцепт Договора - Оферты Исполнителя.
            </p>
            <p>
                1.7. <b>Профиль Пользователя</b> — специальный подраздел Сайта, где расположена Персональная информация о Пользователе, а также другая информация, разместить которую может только этот Пользователь.
            </p>
            <p>
                1.8. <b>Персональные данные</b> - любая информация, которую Пользователь предоставляет о себе самостоятельно при регистрации (создании Профиля Пользователя), или в процессе использования Сайта, включая персональные данные Пользователя, а также информацию, которая автоматически передается Исполнителю в процессе использования Сайта.
            </p>
            <p>
                1.9. <b>Сайт</b> - Интернет-ресурс https://ecodom04.com/, то есть электронный информационный ресурс Исполнителя, отображаемый в текстовом, графическом, аудиовизуальном или ином виде, размещаемый на аппаратно-программном комплексе, имеющий уникальный сетевой адрес и (или) доменное имя и функционирующий в Интернете. 
            </p>
            <p>
                1.10. <b>Заказ</b> - задание Пользователя на оказание Услуг, оформленное в соответствии с условиями Договора-Оферты.
            </p>
            <p>
                1.11. <b>Заказчик</b> — Пользователь, разместивший на Сайте Заказ на оказание Услуг, представленных Исполнителем.
            </p>
            <p>
                1.12. <b>Обработка Персональных данных</b> – действия, направленные на накопление, хранение, изменение, дополнение, использование, распространение, обезличивание, блокирование и уничтожение Персональных данных Пользователей.
            </p>
            <p>
                1.13. <b>База данных</b> — совокупность Информации, размещаемой (размещенной) на Сайте, а также её подбор, группировка и расположение, являющаяся интеллектуальной собственностью Исполнителя.
            </p>
            <p>
                1.14. <b>Партнёры</b> — лица, привлеченные Исполнителем для выполнения Заказов Пользователей.
            </p>
            <h3>
                2. ПРЕДМЕТ ДОГОВОРА – ОФЕРТЫ
            </h3>
            <p>
                2.1. Исполнитель предоставляет возможность Пользователю делать Заказы посредством Сайта https://ecodom04.com/.
            </p>
            <p>
                2.2. Порядок совершения Акцепта:
            </p>
            <p>
                2.2.1. Предложение Исполнителя считается принятым Пользователем с момента совершения им любого из ниже перечисленных действий:
            </p>
            <ul>
                <li>
                    Получая доступ к материалам Сайта (заходя на Сайт в сети интернет https://ecodom04.com/);
                </li>
                <li>
                    Используя Сайт, в том числе его просмотр, поиск информации, использование сервисов;
                </li>
                <li>
                    Выполняя регистрацию с помощью формы на Сайте, (по желанию Пользователя), нажимая галочку «Подтверждаю ознакомление и согласие с условиями Публичной оферты, Условиями использования в полном объёме».
                </li>
            </ul>
            <p>
                2.3. При совершении Пользователем Акцепта в выше описанном порядке считается, что:
            </p>
            <p>
                         2.3.1. Пользователь ознакомлен, согласен и принял предложение Исполнителя;
            </p>
            <p>
                         2.3.2. Акцепт Исполнителем получен;
            </p>
            <p>
                         2.3.3. Договор – Оферта заключен, не требует двустороннего подписания и действителен в электронном виде;
            </p>
            <p>
                         2.3.4. Письменная форма сделки соблюдена.
            </p>
            <p>
                2.4. Использование Сайта Пользователем допускается только в соответствии с настоящим Соглашением и исключительно способами, предусмотренными техническими возможностями Сайта.
            </p>
            <p>
                2.5. Размещая Информацию на Сайте, Пользователь соглашается с тем, что Информация становится доступной для Исполнителя и Партнеров.
            </p>
            <p>
                2.6. Размещая Информацию на Сайте, Пользователь автоматически безвозмездно, безусловно предоставляет Исполнителю право на использование такой Информации без ограничения срока по усмотрению Исполнителя, в том числе на копирование, подбор, систематизацию, преобразование, изменение, редактирование, опубликование, распространение такой Информации (частично или полностью) любыми законными способами для оказания Услуг.
            </p>
            <p>
                2.7. Пользователи обязуются использовать Информацию, а также любую иную информацию, содержащуюся на Сайте только в личных некоммерческих целях.
            </p>
            <h3>
                3. УСЛОВИЯ ОКАЗАНИЯ УСЛУГ
            </h3>
            <p>
                3.1. Использование материалов и сервисов Сайта регулируется нормами действующего законодательства Республики Казахстан.
            </p>
            <p>
                3.2. Пользователь на Сайте оставляет Заказ на Услугу, который оценивается Исполнителем и отображается в соответствующем счете на оплату, дальнейший порядок по оплате Заказа представлен действиями, выполняемыми Заказчиком в последовательности, определяемой Исполнителем.
            </p>
            <p>
                3.3. При оказании Услуг, Заказчик обязуется предоставлять Исполнителю необходимую для выполнения Заказа информацию.
            </p>
            <p>
                3.4. Для выполнения Услуги, Исполнитель имеет право привлекать Партнеров.
            </p>
            <p>
                3.5. Исполнитель может устанавливать для Пользователей рассылку информации, связанной с заказами, и иной необходимой информацией. Необходимая контактная информация предоставляется Пользователем при регистрации, либо при совершении Заказов.
            </p>
            <p>
                3.6. Исполнитель имеет право периодически проводить необходимые профилактические или иные работы без предварительного уведомления Пользователей, Заказчиков и Партнеров.
            </p>
            <p>
                3.7. Сайт может быть временно недоступен, частично или полностью, и соответственно, оказание Услуг может быть временно прекращено, по причине проведения профилактических или иных работ, а также по любым другим причинам Исполнителя.
            </p>
            <h3>
                4. ЦЕНА, ПОРЯДОК И СПОСОБЫ ОПЛАТЫ УСЛУГ
            </h3>
            <p>
                4.1. Заказчик оплачивает за Услуги в порядке и на условиях, указанных в настоящем Пользовательском соглашении.
            </p>
            <p>
                4.2. Стоимость Услуг устанавливается Исполнителем и Партнерами в зависимости от вида Услуг. Стоимость товаров и Услуг, размещенных на сайте Исполнителя является окончательной и не подлежит обсуждению.
            </p>
            <p>
                4.3.  Заказчик может оплатить за Услуги на условиях и по стоимости, указанной на Сайте.
            </p>
            <p>
                4.4. Оплата за Услуги осуществляется в безналичным, наличным расчетом, либо любым из способов, предложенных на Сайте Исполнителя.
            </p>
            <p>
                4.5. Некоторые способы оплаты Услуг могут предусматривать обязательство Заказчика по оплате комиссии или платы за услуги лиц, осуществляющих прием и перечисление платежей, банка и т. п.
            </p>
            <p>
                4.6. Условия осуществления отказа от оформленного Заказа по инициативе Заказчика:
            </p>
            <p>
                4.6.1. Заказ не подтвержден Партнёром в течение – 4 часов;
            </p>
            <p>
                4.6.2. Заказ не выполнен Партнером в согласованные с Заказчиком сроки.
            </p>
            <p>
                4.6.3. Для возврата денежных средств на банковскую карту Заказчику необходимо заполнить «Заявление о возврате денежных средств», которое высылается по требованию Исполнителя на электронный адрес Исполнителя, и оправить его вместе с приложением копии удостоверения по адресу: .
            </p>
            <p>
                4.7. Возврат денежных средств будет осуществлен на банковский счет Заказчика, указанный в заявлении, в течение 10 (десяти) рабочих дней со дня получения «Заявление о возврате денежных средств» Исполнителем.
            </p>
            <p>
                4.8. Исполнитель выполняет возврат денежных средств Заказчику в размере, не превышающем сумму оплаты по Заказу оплаченного Заказчиком с использованием Сервисов для осуществления оплаты представленных на Сайте https://ecodom04.com/.
            </p>
            <p>
                4.9. Случаи, в которых Заказчику может быть отказано в платеже банковской картой на Сайте Исполнителя:
            </p>
            <p>
                4.9.1. Если банковская карта Заказчика не предназначена для совершения платежей через интернет;
            </p>
            <p>
                4.9.2. Если на банковской карте Заказчика недостаточно средств для оплаты;
            </p>
            <p>
                4.9.3. Если данные банковской карты Заказчика введены неверно;
            </p>
            <p>
                4.9.4. Если истек срок действия банковской карты Заказчика;
            </p>
            <p>
                4.10. В случае, если у Заказчика возникла необходимость отмены Заказа, оформленного на Сайте исполнителя и оплаченного банковской картой, возврат денежных средств возможен только путем письменного уведомления Исполнителя о факте отмены Заказа и его причинах в течении 24 часов с момента его оформления. Консультации по оформлению письменному возврату Заказчик может получить в службе технической поддержки Исполнителя по телефону: +7 (707) 304 92 33
            </p>
            <p>
                4.11. Если в течение установленного срока, Заказчик не обратиться с заявлением об аннулировании Заказа и возврате уплаченных денежных средств, то Заказ считается исполненным и денежные средства возврату не подлежат.
            </p>
            <p>
                4.12. Для возврата денежных средств на банковскую карту Заказчику необходимо заполнить «Заявление о возврате денежных средств», которое высылается по требованию Исполнителя на электронный адрес Исполнителя, и его нужно оправить с приложением копии удостоверения по адресу: eco_dom04@mail.ru
            </p>
            <p>
                4.13. Возврат денежных средств будет осуществлен на банковский счет Заказчика, указанный в заявлении, в течение 10 (десяти) рабочих дней со дня получения «Заявление о возврате денежных средств» Исполнителем.
            </p>
            <p>
                4.14. Исполнитель выполняет возврат денежных средств Заказчику в размере, не превышающем сумму оплаты по Заказу оплаченного Заказчиком с использованием Сервисов для осуществления оплаты представленных на Сайте https://ecodom04.com/.
            </p>
            <h3>
                5. БОНУСНАЯ ПОЛИТИКА
            </h3>
            <p>
                5.1. Бонусная политика Исполнителя - это накопительная бонусная программа для Пользователей Сайта, позволяющая использовать накопленные, либо приобретенные Бонусы исключительно для целей, предусмотренных Сайтом https://ecodom04.com/.
            </p>
            <p>
                5.2. Заказчик принимает участие в бонусной программе на условиях, установленных Настоящим Пользовательским Соглашением.
            </p>
            <p>
                5.3. Каждому Пользователю при выполнении определенных действий начисляются Бонусы. Выделены следующие виды Бонусов:
            </p>
            <p>
                       5.3.1. Многоразовые Бонусы- начисляемые при каждом онлайн заказе с Сайта;
            </p>
            <p>
                       5.3.2. Разовые Бонусы- начисляемые при первичной онлайн регистрации на Сайте;
            </p>
            <p>
                5.4. Бонусы не могут быть переданы другим лицам или переведены в денежный эквивалент.
            </p>
            <p>
                5.5. Исполнитель оставляет за собой право изменять правила бонусной программы, включая ее прекращение и изменение по своему усмотрению в одностороннем порядке целиком или частично в любой момент времени.
            </p>
            <p>
                5.6. Исполнитель не несет ответственности за любые убытки, понесенные Заказчиком в результате решения, принятого Исполнителем в отношении бонусной программы.
            </p>
            <p>
                5.7. Срок действия Бонусов не ограничен и прекращается только в случае остановки/прекращения действия Бонусной программы.
            </p>
            <h3>
                6. СОГЛАСИЕ НА СБОР, ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
            </h3>
            <p>
                6.1. В соответствии с законодательством, регламентирующим отношения, связанные со Сбором, Обработкой Персональных данных при совершении Пользователем Акцепта, в порядке, определенном Пользовательским соглашением, Пользователь дает безусловное согласие Исполнителю и Партнерам на Сбор, Обработку, Передачу (при необходимости) Персональных данных Пользователя.
            </p>
            <p>
                6.2. Под Персональными данными Пользователя, Стороны определили нижеследующие сведения, относящиеся к Пользователю, а также происходящие в них в будущем изменения и (или) дополнения, зафиксированные на электронном, бумажном и (или) ином материальном носителе, включая, но, не ограничиваясь: Имя (псевдоним), электронный адрес, адрес указанной для доставки Заказа, номер телефона.
            </p>
            <p>
                6.3. Сбор, Обработка и передача (при необходимости) Персональных данных Пользователя осуществляется Исполнителем для следующих целей, включая, но, не ограничиваясь:
            </p>
            <p>
                       6.3.1. В целях надлежащего исполнения Пользовательского соглашения, а также прав и обязанностей, возложенных на Исполнителя законодательством;
            </p>
            <p>
                       6.3.2. Для внутреннего контроля и учета Исполнителя;
            </p>
            <p>
                       6.3.3.  Для проведения исследований, направленных на улучшение качества Услуг;
            </p>
            <p>
                       6.3.4. Для проведения маркетинговых программ, статистических исследований, проверки, исследования и анализа полученных данных, позволяющих поддерживать, улучшать и разрабатывать новые виды Услуг, а также для продвижения Услуг, в том числе путем направления Пользователю рекламы (том числе, персонализированной (таргетированной), путем осуществления прямых контактов с Пользователем с помощью различных средств связи, включая, но, не ограничиваясь: почтовая рассылка, электронная почта, телефонная и (или) факсимильная связь, сеть Интернет и т.п.);
            </p>
            <p>
                6.4. Размещая на Сайте свою Персональную информацию, Пользователь подтверждает, что делает это добровольно, а также что он добровольно предоставляет данную Информацию Исполнителю.
            </p>
            <p>
                6.5. Пользователь, передавая Исполнителю Персональные данные, по открытым каналам связи, осознает и принимает на себя риск несанкционированного получения их иными лицами и связанные с этим последствия. Исполнитель не несет ответственности при несанкционированном получении Персональных данных иными лицами при их передачи открытыми каналами связи.
            </p>
            <p>
                6.6. При обработке персональных данных Пользователя Исполнитель руководствуется Законом Республики Казахстан от 21 мая 2013 года № 94-V «О персональных данных и их защите».
            </p>
            <p>
                6.7. Пользователь согласен с тем, что использование Сайтом, влечет прохождение процедуры регистрации на Сайте, в том числе в автоматическом режиме, на его электронный адрес будут направляться письма и сообщения, в том числе рекламного характера. Вместе с тем Пользователь дает согласие Исполнителю передавать электронный адрес, персональные данные и иные сведения о Пользователя третьим лицам.
            </p>
            <p>
                6.8. Пользователь даёт согласие на запись телефонных разговоров для повышения качества обслуживания и подтверждения устных заявлений Пользователя.
            </p>
            <p>
                6.9. Пользователь даёт согласие на получение обновлённой информации, информационных сообщений с последними новостями, новыми предложениями, специальными предложениями и объявлениями о продаже, а также информации о новостях и предложениях партнёров Исполнителя посредством SMS и электронной почты.
            </p>
            <h3>
                7. ОТВЕТСТВЕННОСТЬ СТОРОН
            </h3>
            <p>
                7.1. Исполнитель не несет ответственность за качество и скорость доступа к сайту со стороны Пользователя, осуществляемых по каналам связи операторов и Интернет-провайдеров. Сайт может быть временно недоступен, частично или полностью по причине проведения профилактических или иных работ, а также по любым другим причинам технического характера. Исполнитель имеет право периодически проводить необходимые профилактические или иные работы.
            </p>
            <p>
                7.2. Исполнитель не несет ответственности за неисполнение или несвоевременное исполнение обязанностей по оказанию Услуг, возникшее в связи с наступлением обстоятельств, являющихся форс-мажорными, не зависящим от Исполнителя, т.е. обстоятельствами непреодолимой силы, в том числе из-за сбоев в работе телекоммуникационных сетей и оборудования Партнёров. Тем не менее, Исполнитель приложит все усилия, чтобы обеспечить качественное и своевременное предоставление услуг Заказчику.
            </p>
            <p>
                7.3. Исполнитель не несет ответственности за качество еды, напитков и наличие еды и напитков, размещенных на Сайте.
            </p>
            <p>
                7.4. Исполнитель не несёт ответственность за сроки доставки, так как доставка осуществляется непосредственно Партнёрами Исполнителя.
            </p>
            <p>
                7.5. Исполнитель не несет ответственности за задержку исполнения или неисполнения обязанностей, возникшую по вине Партнёров.
            </p>
            <p>
                7.6. Пользователь несет самостоятельно ответственность за сохранение конфиденциальности своих данных регистрации на Сайте, т.е. логина и (или) пароля доступа к личному кабинету. Исполнитель не несет ответственности за любые убытки, причиненные Заказчику, в связи с несанкционированным использованием его личного кабинета, в том числе от оплаты оказанных Исполнителем Услуг.
            </p>
            <p>
                7.7. Исполнитель не несет ответственность за причинение убытков, включая реальный, косвенный, случайный, неумышленный ущерб, упущенную выгоду, вред чести, достоинству или деловой репутации, потерю данных или за причинение любых других убытков Пользователю и Партнёрам, которые возникли при использовании или невозможности использования Сайта, или понесенных в результате ошибок, перерывов, дефектов, задержек в работе, изменения функций Сайта, или передачи и (или) потери данных.
            </p>
            <p>
                7.8. Стороны несут ответственность в пределах возложенных на них настоящим договором обязательств. Во всем остальном, что не урегулировано настоящим пользовательским соглашением, Стороны руководствуются нормами действующего законодательства Республики Казахстан.
            </p>
            <p>
                7.9. Исполнитель старается обеспечить надлежащее функционирование Сайта в круглосуточном режиме, однако Исполнитель не несет никакой ответственности, если произойдут какие-либо нарушения в работе Сайта по любым причинам.
            </p>
            <p>
                7.10. Исполнитель не гарантирует, что Информация, размещенная на Сайте, будет доступна в любое время, или не будет удалена или утеряна.
            </p>

            <h3>
                8. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
            </h3>
            <p>
                8.1. Настоящее Соглашение регулируется и толкуется в соответствии с законодательством Республики Казахстан. Вопросы, не урегулированные Настоящим Соглашением, подлежат разрешению в соответствии с законодательством Республики Казахстан. Все возможные споры, вытекающие из отношений, регулируемых настоящим Соглашением, разрешаются в порядке, установленном действующим законодательством Республики Казахстан.
            </p>
            <p>
                8.2. Настоящее Соглашения действует в течение всего периода использования Сайта Пользователем.
            </p>
            <p>
                8.3. Исполнитель вправе в любое время изменять условия настоящего Соглашения, публикуя новую редакцию на Сайте. Пользователь обязуется регулярно просматривать опубликованный на Сайте текст Соглашения с целью ознакомления об изменениях.
            </p>
            <p>
                8.4. Настоящее Соглашение регулируется и толкуется в соответствии с законодательством Республики Казахстан. Вопросы, не урегулированные настоящим Соглашением, подлежат разрешению в соответствии с законодательством Республики Казахстан. Все возможные споры, вытекающие из отношений, регулируемых настоящим Соглашением, разрешаются в порядке, установленном действующим законодательством Республики Казахстан.
                Все споры и разногласия, вытекающие из правоотношений по настоящей Оферте, будут разрешаться путем переговоров. В случае невозможности разрешить споры и разногласия путем переговоров они подлежат рассмотрению в соответствующем суде по месту нахождения Исполнителя, с обязательным соблюдением претензионного порядка. Срок ответа на претензию составляет 30 (тридцать) календарных дней.
            </p>
            <p>
                8.6. Исполнитель в любое время без какого-либо специального уведомления. Новая редакция Соглашения вступает в силу с момента ее опубликования на Сайте, если иное не предусмотрено новой редакцией Соглашения.
            </p>
            <p>
                8.7. При несогласии Пользователя с внесенными изменениями, он обязан отказаться от доступа к Сайту, прекратить использование материалов и сервисов
            </p>
            <p>
                8.8. Пользователь обязуется регулярно просматривать опубликованный на Сайте текст Соглашения с целью ознакомления об изменениях.
            </p>
        </div>    
  </div>
</template>

<script>
export default {
  name: 'policy',
  components: {
  },
  data () {
      return {
         
      }
  },
  methods: {
     
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.policy {
    width: 1200px;
    margin: 0 auto;
    background: white;
    @media (max-width: @baseMedia) {
        width: 95%;
    }
    .policy__title {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        @media (max-width: @baseMedia) {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        h1 {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 20px;
            }
        }
    }
    .policy_margin {
        width: 95%;
        margin: 0 auto;
        padding-bottom: 20px;
        h3 {
            margin-bottom: 15px;
            font-size: 20px;
            color: #4a4a4a;
            @media (max-width: @baseMedia) {
                font-size: 18px;
            }
        }
        p {
            margin-bottom: 15px;
            font-size: 17px;
            color: #4a4a4a;
            @media (max-width: @baseMedia) {
                font-size: 15px;
            }
        }
        ul {
            margin-bottom: 15px;
            margin-left: 35px;
            color: #4a4a4a;
        }
        li {
            font-size: 17px;
            @media (max-width: @baseMedia) {
                font-size: 15px;
            }
        }
    }
}
</style>